import { useTranslation } from 'react-i18next';

import camelRating from '~/assets/img/dubaiexpress/camel-rating.svg';
import ChevronRightIcon from '~/components/MarketplaceIcons/ChevronRightIcon';
import type { ProductReview } from '~/types/Product/interface';

import { INLINE_LINK_CLASS, SECTION_TITLE_CLASS } from '../constants';

interface Props {
  rating: number;
  totalRatings: number;
  /** Latest loaded review, quoted under the rating box. */
  topReview?: ProductReview;
  onShowAll: () => void;
}

/**
 * Compact rating block in the info column of the DubaiExpress product page.
 * Links to the full review section further down the page.
 */
export const ProductDEReviewsSummary = ({
  rating,
  totalRatings,
  topReview,
  onShowAll,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div>
      <h2 className={`${SECTION_TITLE_CLASS} mb-2.5!`}>{t('reviews')}</h2>
      <div className="rounded-[10px] border border-[#EDEDED] border-solid px-4 py-3.5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <span className="flex items-center gap-2">
            <span className="flex items-center gap-[5px]">
              <span className="font-semibold text-[#141415] text-[20px] leading-[26px] tracking-[-0.01em]">
                {rating}
              </span>
              <img
                src={camelRating}
                alt=""
                className="block h-4 w-auto shrink-0"
              />
            </span>
            <span className="text-[#8A8A8A] text-[14px] leading-5">
              {t('ratingsCount', { count: totalRatings })}
            </span>
          </span>
          <button
            type="button"
            onClick={onShowAll}
            className={INLINE_LINK_CLASS}
          >
            {t('allReviews')}
            <ChevronRightIcon className="size-4" />
          </button>
        </div>
      </div>
      {topReview && (
        <p className="m-0 mt-2.5! text-pretty text-[#5C5C5C] text-[14px] leading-5">
          «{topReview.content}»
        </p>
      )}
    </div>
  );
};
